module.exports = __webpack_public_path__ + "static/media/noImg.78a8b903.png";